import type { IterableLike } from "../types/IterableLike"
import { to_array } from "./to_array"

/**
 * Applies function with iterable arguments.
 *
 * Converts args to array and applies to function. Similar to Function.prototype.apply.
 *
 * @param f - Function to apply
 * @param args - Arguments as iterable or primitive
 * @returns Result of function application
 *
 * @example
 * ```ts
 * import { apply } from "@pdfking/rfunc"
 *
 * apply((a, b) => a + b, [1, 2]) // 3
 * ```
 */
type Args<F> = F extends (...args: infer A) => unknown ? A : never
type Return<F> = F extends (...args: never[]) => infer R ? R : never

export const apply = <F extends (...args: any[]) => unknown>(
  f: F,
  args: IterableLike<Args<F>[number]>
): Return<F> => f.apply(null, to_array(args)) as Return<F>
